import { Injectable, InjectionToken } from '@angular/core';
import { PASCAL_TO_CAMEL_CASE_NORMALIZER } from '@core/utils';
import { Review, ReviewsInfo, ReviewsInfoPayload, ReviewsInfoResponse } from '@reviews/const';
import { Converter, ConverterService } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ReviewsNormalizer implements Converter<ReviewsInfoResponse, ReviewsInfo> {
  constructor(private converter: ConverterService) {}

  convert(source: ReviewsInfoResponse): ReviewsInfo {
    const result = this.converter.convert<ReviewsInfoPayload, ReviewsInfo>(
      source.data,
      PASCAL_TO_CAMEL_CASE_NORMALIZER,
    );

    result.reviews = result.reviews.map((review: Review) => {
      review.date = new Date(review.date);

      return review;
    });

    return result;
  }
}

export const REVIEWS_NORMALIZER = new InjectionToken<ReviewsNormalizer>('ReviewsPayloadNormalizer');
